import { Type } from 'class-transformer';

import { Model } from './model';

export enum InboxCategory {
  ALL = 'all',
  DRAFTS = 'drafts',
  IRRELEVANT = 'irrelevant',
  SENT = 'sent',
  SPAM = 'spam',
  TRIAGE = 'triage',
}

/** Category counts for internal email threads (nested under `Inbox.internal`). */
export class InboxInternalStatus {
  all = 0;

  unread = 0;

  drafts = 0;

  sent = 0;
}

export class Inbox extends Model {
  drafts: number;

  sent: number;

  all: number;

  unread: number;

  triage: number;

  dismissed: number;

  @Type(() => InboxInternalStatus)
  internal: InboxInternalStatus = new InboxInternalStatus();
}
